/* eslint-disable linebreak-style */

export type TTypeMethodPaymentId = 1 | 2 | 3 | 4;

export interface MethodPaymentType {
  id: TTypeMethodPaymentId;
  name: string;
  icon: string;
}

export const IdentifierTypeMethodPayment: MethodPaymentType[] = [
  { id: 1, name: 'EFECTIVO', icon: 'pi pi-money-bill' },
  { id: 2, name: 'TARJETA', icon: 'pi pi-credit-card' },
  { id: 3, name: 'BILLETERA', icon: 'pi pi-wallet' },
  { id: 4, name: 'BANCO', icon: 'pi pi-building' }
];
